import { render, staticRenderFns } from "./LiveEventView.vue?vue&type=template&id=367d3859"
import script from "./LiveEventView.vue?vue&type=script&lang=js"
export * from "./LiveEventView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports